<template>
    <b-row>
        <b-col cols="3">
            <div class="pr-5">
                <h2>Your Account</h2>
                <p>Review and edit your settings.</p>

                <h5>{{ user.firstName + ' ' + user.lastName }}</h5>
                <p>{{ user.email }}</p>
                <h5>{{ user.client.client }}</h5>

                <hr class="my-5">
            </div>
        </b-col>
        <b-col cols="9">
            <div class="border rounded bg-secondary px-3 py-3">
                <vue-element-loading :active="loading" :is-full-screen="false"/>
                <User-Form :userId="user.userId"></User-Form>
            </div>
            <b-btn class="mt-3" variant="primary">Save Changes</b-btn>
        </b-col>
    </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UserForm from '@/components/User/UserForm';

export default {
  name: 'Account-Details',
  components: {
    UserForm,
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
      }
    };
  },
  computed: {
    ...mapGetters({ user: 'authUser' }),
  },
  mounted() {
    this.fetchUser();
  },
  methods: {
    ...mapActions(['fetchUser']),
  },
};
</script>

<style scoped>
</style>
